import { render, staticRenderFns } from "./LanguageSelector.vue?vue&type=template&id=3e2d1c74&"
import script from "./LanguageSelector.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LanguageSelector.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports